import { createContext } from 'react';
import type { Folder } from '../types/GraphqlTypes';
import type { InboxPageMobileView } from '../types/InboxPageMobileView';

type ContextProps = {
  /**
   * Selected conversation
   */
  conversationId?: string;
  /**
   * Selected folder
   */
  folder: Folder;
  /**
   * Column that is currently in view on mobile
   */
  mobileView: InboxPageMobileView.ConversationList | InboxPageMobileView.MessageList;
};

/**
 * InboxPageContext stores data specific to the inbox page.
 */
export const InboxPageContext = createContext<ContextProps>({} as ContextProps);
export const InboxPageContextProvider = InboxPageContext.Provider;
